import Cookies from 'js-cookie';

Date.prototype.Format = function(fmt)
{ //author: meizz
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(fmt))
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}

Date.prototype.Parse = function(str) {
  let group = str.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)
  this.setFullYear(group[1]);
  this.setMonth(parseInt(group[2])-1, group[3]);
  // this.setDate();
  this.setHours(0);
  this.setMinutes(0);
  this.setSeconds(0);
  this.setMilliseconds(0);
}

let host = window.location.host;
if (host == "localhost:8080") {
  // host = "https://admin.arabonline.cn";
  host = "https://data.91mgame.com";
} else {
  host = "https://data.91mgame.com";
  // host = `https://${host}`;
}

let storage = {
	token: Cookies.get("token"),
	// url: "http://120.27.212.253:13491",
	// url: "https://dat.311419.cn",
	// url: "https://admin.arabonline.cn",
	url: host,
	// url: window.localStorage.getItem("rqurl"),
  login_url: host,
  // login_url: "https://admin.arabonline.cn",
	isLogined: false,
	user: null,

    login(token) {
        this.token = token;
        Cookies.set("token", token);
    },
    logout() {
        this.token = null;
        Cookies.remove("token");
    },
    get(key) {
        return window.localStorage.getItem(key);
    },
    set(key, value) {
        window.localStorage.setItem(key, value)
    }
}

export default storage